import vuex from "vuex";
import localStorage from "../../helper/localStorage";
import http from "../../helper/http";


/**
 * 商品及类型
 */

const state = {
  /**
   * 特殊服务列表
   */
  otherServiceList: []
}

const getters = {

}

const actions = {
  /**
   * 获取订单列表
   * @param {*} param0 
   * @param {*} params 
   */
  async getOtherServiceList({
    state,
    commit
  }, ordercode) {
    await commit('setStateData', {
      otherServiceList: []
    });
    let dataList = await http.get(
      "/order/getorderotherservice?ordercode=" + ordercode
    );
    return await commit('setStateData', {
      otherServiceList: dataList
    });
  },
}

const mutations = {
  setStateData(state, params) {
    for (var key in params) {
      state[key] = params[key];
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/order.js